<template>
  <div class="mt-6 w-full">
    <div class="mb-3 flex justify-start">
      <CompareStyleToggle :model-value="isVisible" @update:model-value="handleToggle" />
    </div>

    <div
      class="overflow-hidden transition-all duration-700"
      :class="isVisible ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'"
    >
      <div class="mt-3 rounded-xl bg-light-blue p-4">
        <IAIScrollableContainer class="w-full">
          <div class="flex items-center gap-4 p-2">
            <CompareStyleItem
              v-for="image in compareStyleImageList"
              :key="image.key"
              :image="image"
              :is-selected="selectedImage === image.key"
              @select="selectedImage = image.key"
            />
          </div>
        </IAIScrollableContainer>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineProps, computed } from "vue";
import { IAIScrollableContainer } from "@/core-ui-vue";
import CompareStyleItem from "./CompareStyleItem.vue";
import { CompareStyleImages } from "@/features/profile-shop/services/api";
import CompareStyleToggle from "./CompareStyleToggle.vue";
import { t } from "@/locales/vue";
import originalImage from "@/features/profile-shop/assets/compare-style-originals.png";
interface Props {
  originalImages: CompareStyleImages;
}

const props = defineProps<Props>();

const isVisible = ref(false);
const selectedImage = defineModel<keyof CompareStyleImages>("selectedImage", { required: true });

const compareStyleImageList = computed(() => {
  const originalImages = Object.entries(props.originalImages).map(([key, value]) => ({
    key: key,
    src: value,
    alt: t("pages.profile-shop.compare-style.option-alt", { option: key }),
  }));

  return [
    {
      key: "original",
      src: originalImage.src,
      alt: t("pages.profile-shop.compare-style.originals-alt"),
    },
    ...originalImages,
  ];
});

const handleToggle = (value: boolean) => {
  if (!value) {
    selectedImage.value = "original";
  }

  isVisible.value = value;
};
</script>
